import { render, staticRenderFns } from "./RecycleBins.vue?vue&type=template&id=357d8f0e&scoped=true&"
import script from "./RecycleBins.vue?vue&type=script&lang=js&"
export * from "./RecycleBins.vue?vue&type=script&lang=js&"
import style0 from "./RecycleBins.vue?vue&type=style&index=0&id=357d8f0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357d8f0e",
  null
  
)

export default component.exports